import { withInstall } from '@vuesax-plus/utils'

import StarFilled from './src/star-filled.vue'

export const IconStarFilled = withInstall(StarFilled)

export default IconStarFilled
